<div
  class="header header-content pb-6 pt-4 pt-lg-5 d-flex align-items-center"
  [style.min-height]="minHeight"
  [style.background-image]="'url(' + backgroundImage + ')'"
  style="background-size: cover; background-position: center top;">
  <span class="header-content__overlay"></span>
  <span class="header-content__glow"></span>
  <div class="container-fluid d-flex align-items-center position-relative">
    <div class="row w-100 glass-header">
      <div [class]="contentColumnClass">
        <div class="header-content__panel">
          <div class="header-content__slot">
            <ng-content></ng-content>
          </div>
          @if(title) {
          <span class="header-content__eyebrow"></span>
          <h1 class="header-content__title">{{ title }}</h1>
          }
          @if(text) {
          <p [class]="'header-content__text ' + textClass">{{ text }}</p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
